import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-[#060F1E] text-slate-200 antialiased" data-testid="site-layout">
      <Navigation />
      <main className="relative pt-16" key={location.pathname}>
        <div className="page-enter">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
